// DashboardListUIContext.tsx
import type React from "react";
import { createContext, useContext, useEffect, useState } from "react";

type DashboardListUI = {
  expandAll: boolean;
  setExpandAll: (v: boolean) => void;
  toggleExpandAll: () => void;
};

const Ctx = createContext<DashboardListUI | null>(null);

export const DashboardListUIProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [expandAll, setExpandAll] = useState<boolean>(() => {
    try {
      const raw = localStorage.getItem("mm.dashboard.expandAll");
      return raw != null ? JSON.parse(raw) : false;
    } catch {
      return false;
    }
  });

  // persist to localStorage (after state changes)
  useEffect(() => {
    try {
      localStorage.setItem("mm.dashboard.expandAll", JSON.stringify(expandAll));
    } catch {
      // no-op
    }
  }, [expandAll]);

  return (
    <Ctx.Provider
      value={{
        expandAll,
        setExpandAll,
        toggleExpandAll: () => setExpandAll((v) => !v),
      }}
    >
      {children}
    </Ctx.Provider>
  );
};

export const useDashboardListUI = () => {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useDashboardListUI must be used within DashboardListUIProvider");
  return ctx;
};
